import {SERVER} from "../constants";
import {stringify} from "query-string";
import {MAP_URL} from "../constants/urls";
import {HttpClient} from "../utils/requests";

export function deleteMany(resource, params) {
  const query = {
    filter: JSON.stringify({id: params.ids}),
  };
  return HttpClient(`${SERVER}/${MAP_URL[resource]}?${stringify(query)}`, {
    method: "DELETE",
    body: JSON.stringify(params.data),
  }).then(({json}) => {
      return {
        data: json,
      };
    }
  );
}